import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeResourceUrl',
})
export class SafeResourceUrlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) {}

  public transform(value: any, args?: any): any {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
